import React from "react"
import {Modal} from "../../Modals/Modal"
import Button from "../../Button/Button"

export default function ReevaluateApplicationCancelingModal(props: {close: () => void; onSavingCallback: () => void}) {
	const {close, onSavingCallback} = props
	return (
		<Modal close={close} classname="reevaluate-application-canceling-modal">
			<h3>You have unsaved changes</h3>
			<p>The changes you made will not be saved, are you sure you wish to proceed?</p>
			<footer>
				<Button theme="neutral" size="normal" variant="outline" onClick={close}>
					Keep editing
				</Button>
				<Button theme="danger" size="normal" variant="outline" onClick={onSavingCallback}>
					Leave without saving
				</Button>
			</footer>
		</Modal>
	)
}
